export default __webpack_public_path__ + "static/media/KK_R_Left_Top_a-cropped.9dfd0002.svg";